import { render, staticRenderFns } from "./RuleManagementList.vue?vue&type=template&id=22f87e1c&"
import script from "./RuleManagementList.vue?vue&type=script&lang=js&"
export * from "./RuleManagementList.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagementList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports